export const isTestAdmin = (): boolean => {
  return window.location.hostname === "test-admin.vider.in";
  // return window.location.hostname === "admin.vider.in";
  // return window.location.hostname === "localhost";

};